module.exports = __webpack_public_path__ + "img/docx.24c26b61.svg";